import isResizable from './is-resizable';

export default {
  isResizable,
};
